import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { getCampaignId, getUTMValues } from './AmexGDAOffersDetails';
import AmexGDAOffersBenefits from './AmexGDAOffersBenefits';
import AmexGDAOffersCards from './AmexGDAOffersCards';
import { ACQUISITION_CTA_EVENT_NAME } from '../../AmexMarketingUtils/constants';
import { handleMktAnalytics } from '../../AmexMarketingUtils/AmexUtils';
import './AmexGDAOffers.scss';

const PLATINUM_CODE = '2X';
const PLATINUM_CARD = 'plat';

const AmexGDAOffers = (props) => {
  const {
    offersResyData,
    offersResyAmexData,
    showNaa2025,
    Analytics,
    matchMedia,
    baseRequestUrl,
    referrer,
    gdaHiltonDeltaCardOrder,
  } = props;

  const [showPlatOfferDetails, setShowPlatOfferDetails] = useState(false);
  const {
    api_products: products,
    icon_mappings: iconMappings,
    acquisition_heading: acquisitionHeading,
    acquisition_content: acquisitionContent,
    acquisition_heading_new: acquisitionHeadingNew,
    acquisition_content_new: acquisitionContentNew,
  } = offersResyData;

  const [productDetails] = products.filter((product) => product.product_code
   === PLATINUM_CODE);

  const amexCardData = () => {
    const {
      urls,
      product_name: productName,
      fees,
      content_groups: contentGroups,
      rates,
    } = offersResyAmexData;

    const imagePath = urls.filter((url) => url.name === 'CARD_ART_URL')[0]?.value;
    const applyNowLink = urls.filter((url) => url.name === 'APPLY_URL')[0]?.value;
    const offersAndBenefitsLink = urls.filter((url) => url.name === 'OFFER_TERMS_URL')[0]?.value;
    const ratesAndFeesLink = urls.filter((url) => url.name === 'TERMS_AND_CONDITIONS_URL')[0]?.value;
    const contentGrpBenefits = contentGroups.filter((content) => content.name === 'BENEFITS_TEXT');
    const contentGrpMarketingOffer = contentGroups.filter((content) => content.name === 'MARKETING_OFFER_TEXT');
    const marketingContent = contentGrpMarketingOffer[0]?.contents[0];
    const benefitArray = contentGrpBenefits[0]?.contents;
    const benefitArrayReOrdered = benefitArray.sort((a, b) => a.sequence_order - b.sequence_order);

    return {
      imagePath,
      productName,
      applyNowLink,
      offersAndBenefitsLink,
      ratesAndFeesLink,
      fees,
      marketingContent,
      rates,
      benefitArrayReOrdered,
    };
  };

  const resyCardData = () => {
    const {
      image_alt: imageAlt,
      offer_badge: offerBadge,
      offer_badge_new: offerBadgeNew,
      apr_symbol: aprSymbol,
      apr_name: aprName,
      annual_fee_symbol: annualFeeSymbol,
      rate_and_fees_aria_label: rateAndFeesAriaLabel,
      rate_and_fees_track: rateAndFeesTrack,
      offer_benefit_terms_aria_label: offerBenefitTermsAriaLabel,
      offer_benefit_terms_track: offerBenefitTermsTrack,
      apply_now_track: applyNowTrack,
      apply_now_aria_label: applyNowAriaLabel,
      apr_pay_over_time_text: aprPayOverTimeText,
      card_cta_campaign_link: cardCtaCampaignLink,
      rate_and_fees_label: productRateAndFeesLabel,
      offer_benefit_terms_label: productOfferBenefitTermsLabel,
      rate_and_fees_symbol: productRateAndFeesSymbol,
      offer_benefit_terms_symbol: productOfferBenefitTermsSymbol,
      annual_fee_label: productAnnualFeeLabel,
      apply_link_label: productApplyLinkLabel,
      benefits_title: productBenefitsTitle,
      show_more_label: showMoreLabel,
      show_less_label: showLessLabel,
      hide_link_label: hideLinkLabel,
    } = productDetails;

    return {
      imageAlt,
      offerBadge,
      offerBadgeNew,
      aprSymbol,
      aprName,
      annualFeeSymbol,
      rateAndFeesAriaLabel,
      rateAndFeesTrack,
      offerBenefitTermsAriaLabel,
      offerBenefitTermsTrack,
      applyNowTrack,
      applyNowAriaLabel,
      productRateAndFeesLabel,
      productRateAndFeesSymbol,
      productOfferBenefitTermsLabel,
      productOfferBenefitTermsSymbol,
      productApplyLinkLabel,
      productAnnualFeeLabel,
      productBenefitsTitle,
      iconMappings,
      showMoreLabel,
      showLessLabel,
      hideLinkLabel,
      aprPayOverTimeText,
      cardCtaCampaignLink,
    };
  };

  const openCardDetails = (element) => {
    const target = document.querySelector(element);
    if (target) {
      setTimeout(() => target.focus(), 0);
      target.scrollIntoView({ behavior: 'smooth' });
    }
    setShowPlatOfferDetails(!showPlatOfferDetails);
  };

  const clickShowDetails = (link) => {
    const showPlatOfferDetailsValue = !showPlatOfferDetails ? 'NAA - Platinum Show Featured Benefits Click' : 'NAA - Platinum Hide Featured Benefits Click';
    handleMktAnalytics(Analytics.event, ACQUISITION_CTA_EVENT_NAME, { action_name: showPlatOfferDetailsValue });
    openCardDetails(link);
  };

  const isDesktopMedia = !!(matchMedia.lg);
  const platProductDetails = resyCardData();

  const platCardProps = {
    cardName: PLATINUM_CARD,
    productCode: PLATINUM_CODE,
    key: PLATINUM_CODE,
    amexCardData: amexCardData(),
    resyCardData: platProductDetails,
    Analytics,
    showPlatOfferDetails,
    baseRequestUrl,
    campaignId: getCampaignId(platProductDetails),
    utmValues: getUTMValues(platProductDetails),
  };
  const showBenefits = isDesktopMedia && showPlatOfferDetails;
  return (
    <div className={cx('AmexGDAOffers', { naa2025: showNaa2025 })}>
      <div className="container">
        <article className="AmexGDAOffers__gdawrapper main-content">
          <div className="AmexGDAOffers__gdacardwrapper">
            <h2 className="AmexGDAOffers__gdaacquisition__heading">{ showNaa2025 ? acquisitionHeadingNew : acquisitionHeading }</h2>
            <p className="AmexGDAOffers__gdaacquisition__content">{ showNaa2025 ? acquisitionContentNew : acquisitionContent }</p>
            <ul className="AmexGDAOffers__gdaacquisition__grid">
              <AmexGDAOffersCards
                offersResyData={offersResyData}
                showNaa2025={showNaa2025}
                baseRequestUrl={baseRequestUrl}
                Analytics={Analytics}
                referrer={referrer}
                newGdaAllCardProductOrder={gdaHiltonDeltaCardOrder}
                platCardProps={platCardProps}
                clickShowDetails={clickShowDetails}
                isDesktopMedia={isDesktopMedia}
              />
            </ul>
          </div>
        </article>
      </div>
      {showBenefits && (
        <AmexGDAOffersBenefits
          {...platCardProps}
          clickShowDetails={clickShowDetails}
          isDesktopMedia={isDesktopMedia}
          Analytics={Analytics}
        />
      )}
    </div>
  );
};

AmexGDAOffers.defaultProps = {
  referrer: '',
};

AmexGDAOffers.propTypes = {
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  offersResyData: PropTypes.shape({
    api_products: PropTypes.arrayOf(PropTypes.shape({
      rate_and_fees_label: PropTypes.string,
      offer_benefit_terms_label: PropTypes.string,
      rate_and_fees_symbol: PropTypes.string,
      offer_benefit_terms_symbol: PropTypes.string,
      annual_fee_label: PropTypes.string,
      apply_link_label: PropTypes.string,
      benefits_title: PropTypes.string,
    })),
    icon_mappings: PropTypes.arrayOf(PropTypes.shape()),
    acquisition_heading: PropTypes.string,
    acquisition_content: PropTypes.string,
    acquisition_heading_new: PropTypes.string,
    acquisition_content_new: PropTypes.string,
    show_more_label: PropTypes.string,
    show_less_label: PropTypes.string,
    hide_link_label: PropTypes.string,
    all_card_product_order_desktop: PropTypes.string,
    all_card_product_order_mobile: PropTypes.string,
  }).isRequired,
  offersResyAmexData: PropTypes.shape({
    fees: PropTypes.arrayOf(PropTypes.shape()),
    urls: PropTypes.arrayOf(PropTypes.shape()),
    content_groups: PropTypes.arrayOf(PropTypes.shape()),
    product_name: PropTypes.string,
    rates: PropTypes.arrayOf(PropTypes.shape()),
  }).isRequired,
  baseRequestUrl: PropTypes.string.isRequired,
  referrer: PropTypes.string,
  gdaHiltonDeltaCardOrder: PropTypes.string.isRequired,
  matchMedia: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    ipadLandscape: PropTypes.bool,
    xl: PropTypes.bool,
  }).isRequired,
  showNaa2025: PropTypes.bool.isRequired,
};

export default AmexGDAOffers;
